import React, { Component } from 'react';
import * as FontAwesome from 'react-icons/lib/fa';

export default class SubHeader extends Component {
  render() {
    return (
      <div className="pm-page-header pm-page-header--in-card">
        <div className="pm-page-header__title-block">
          <h1 className="pm-page-title">Periodical Master</h1>
          <p className="pm-page-subtitle">Cleaner list with search, frequency mapping and status.</p>
        </div>
        <div className="pm-page-header__actions">
          <button className="pm-add-btn" onClick={this.props.toggle}>
            <FontAwesome.FaPlusCircle className="pm-add-btn__icon" />
            Add New Periodical
          </button>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/Periodicals/periodical_subheader.js